"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingPricing.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-29":{"id":"e-29","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-30"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e10","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e10","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":150,"direction":"BOTTOM","effectIn":true},"createdOn":1691534703276},"e-31":{"id":"e-31","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-388"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e13","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e13","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1691534703276},"e-57":{"id":"e-57","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-58"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e2a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e2a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"BOTTOM","effectIn":true},"createdOn":1691771397210},"e-59":{"id":"e-59","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-60"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e1f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e1f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1691771411198},"e-61":{"id":"e-61","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-62"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e16","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"14afbff6-05fe-5b65-e9f4-0e4163509e16","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1691771428534}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingPricing({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "sponsored-listings-pricing")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="SponsoredListingPricing"
    >
      <_Builtin.Container
        className={_utils.cx(_styles, "sponsored-listings-pricing-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(
            _styles,
            "sponsored-listings-pricing-main-block"
          )}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "sponsored-listing-pricing-text")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "home-page-creative-text")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "inline-text")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(
                    _styles,
                    "sponsored-listings-pricing-heading"
                  )}
                  data-w-id="14afbff6-05fe-5b65-e9f4-0e4163509e10"
                  tag="h2"
                >
                  {"Quality leads at flexible rates"}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block tag="div">
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "sponsored-listings-pricing-paragraph"
                  )}
                  data-w-id="14afbff6-05fe-5b65-e9f4-0e4163509e13"
                >
                  {
                    "Discover cost-effective pricing packages that help you fill vacancies fast, when you need it most."
                  }
                </_Builtin.Paragraph>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "sponsored-listings-pricing-cards")}
            id={_utils.cx(
              _styles,
              "w-node-_14afbff6-05fe-5b65-e9f4-0e4163509e15-63509e0a"
            )}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "sponsored-listing-pricing-card")}
              data-w-id="14afbff6-05fe-5b65-e9f4-0e4163509e16"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listing-pricing-card-text"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "sponsored-listings-price-text"
                  )}
                  tag="div"
                >
                  {"28 days"}
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-2")}
                  tag="div"
                >
                  {"Sponsored Listing"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listings-pricing-actions"
                )}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "button-primary")}
                  button={true}
                  id="sl-buy-30day"
                  block=""
                  options={{
                    href: "/boost-a-listing?accountType=essentials",
                  }}
                >
                  {"Starting at $1.79/day"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "sponsored-listing-pricing-card")}
              data-w-id="14afbff6-05fe-5b65-e9f4-0e4163509e1f"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listing-pricing-card-text"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "sponsored-listings-price-text"
                  )}
                  tag="div"
                >
                  {"14 days"}
                  <_Builtin.Strong className={_utils.cx(_styles, "bold-text")}>
                    {""}
                  </_Builtin.Strong>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-2")}
                  tag="div"
                >
                  {"Sponsored Listing"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listings-pricing-actions"
                )}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "button-primary")}
                  button={true}
                  id="sl-buy-14day"
                  block=""
                  options={{
                    href: "/boost-a-listing?accountType=essentials",
                  }}
                >
                  {"Starting at $1.79/day"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "sponsored-listing-pricing-card")}
              id={_utils.cx(
                _styles,
                "w-node-_14afbff6-05fe-5b65-e9f4-0e4163509e2a-63509e0a"
              )}
              data-w-id="14afbff6-05fe-5b65-e9f4-0e4163509e2a"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listing-pricing-card-text"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "sponsored-listings-price-text"
                  )}
                  tag="div"
                >
                  {"7 days"}
                  <_Builtin.Strong className={_utils.cx(_styles, "bold-text")}>
                    {""}
                  </_Builtin.Strong>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-2")}
                  tag="div"
                >
                  {"Sponsored Listing"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "sponsored-listings-pricing-actions"
                )}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "button-primary")}
                  button={true}
                  id="sl-buy-7day"
                  block=""
                  options={{
                    href: "/boost-a-listing?accountType=essentials",
                  }}
                >
                  {"Starting at $2.86/day"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
    </_Component>
  );
}
